import React, { useState } from 'react';
import { Home, User, Phone, Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { AgentConfig } from '../config/agents';

interface HeaderProps {
  agent: AgentConfig;
}

export default function Header({ agent }: HeaderProps) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const navigateAndCloseMenu = (path: string) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div 
            className="flex-shrink-0 cursor-pointer" 
            onClick={() => navigateAndCloseMenu('/')}
          >
            <h1 className="text-2xl font-bold text-navy-900">Monroe Davis</h1>
            <p className="text-sm text-accent">Real Estate Agent</p>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={toggleMenu}
            className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-navy-900 hover:bg-gray-100 focus:outline-none"
          >
            {isMenuOpen ? (
              <X className="block h-6 w-6" aria-hidden="true" />
            ) : (
              <Menu className="block h-6 w-6" aria-hidden="true" />
            )}
          </button>

          {/* Desktop navigation */}
          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => navigate('/')} 
              className="flex items-center text-gray-700 hover:text-navy-900"
            >
              <Home className="w-4 h-4 mr-1" />
              Home
            </button>
            <button 
              onClick={() => navigate('/about')} 
              className="flex items-center text-gray-700 hover:text-navy-900"
            >
              <User className="w-4 h-4 mr-1" />
              About
            </button>
            <button 
              onClick={() => navigate('/contact')} 
              className="flex items-center text-gray-700 hover:text-navy-900"
            >
              <Phone className="w-4 h-4 mr-1" />
              Contact
            </button>
          </nav>
        </div>

        {/* Mobile menu */}
        <div
          className={`${
            isMenuOpen ? 'block' : 'hidden'
          } md:hidden absolute top-full left-0 right-0 bg-white shadow-lg z-50`}
        >
          <div className="px-2 pt-2 pb-3 space-y-1">
            <button
              onClick={() => navigateAndCloseMenu('/')}
              className="w-full flex items-center px-3 py-2 text-gray-700 hover:text-navy-900 hover:bg-gray-100 rounded-md"
            >
              <Home className="w-4 h-4 mr-2" />
              Home
            </button>
            <button
              onClick={() => navigateAndCloseMenu('/about')}
              className="w-full flex items-center px-3 py-2 text-gray-700 hover:text-navy-900 hover:bg-gray-100 rounded-md"
            >
              <User className="w-4 h-4 mr-2" />
              About
            </button>
            <button
              onClick={() => navigateAndCloseMenu('/contact')}
              className="w-full flex items-center px-3 py-2 text-gray-700 hover:text-navy-900 hover:bg-gray-100 rounded-md"
            >
              <Phone className="w-4 h-4 mr-2" />
              Contact
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}